import Vue from 'vue'
import { mergeData } from 'vue-functional-data-merge'

import './SvgIcon.scss'

export default Vue.extend({
  name: 'SvgIcon',
  functional: true,
  props: {
    path: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  render(h, { props, data }) {
    return h(
      'svg',
      mergeData(data, {
        attrs: {
          viewBox: '0 0 24 24',
          focusable: 'false',
          'aria-label': props.label,
        },
        staticClass: 'svg-icon',
      }),
      [h('path', { attrs: { d: props.path } })]
    )
  },
})
